import React, { useState } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { MailIcon } from 'lucide-react';
export const EmailSupport = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-7146">
      <Navbar scrolled={scrolled} data-id="element-7147" />
      <main className="pt-24 pb-20" data-id="element-7148">
        <div className="container mx-auto px-4 md:px-6" data-id="element-7149">
          <div className="max-w-3xl mx-auto bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm" data-id="element-7150">
            <div className="flex flex-col items-center text-center mb-8" data-id="element-7151">
              <div className="w-16 h-16 bg-[#2DB489]/10 rounded-full flex items-center justify-center mb-4" data-id="element-7152">
                <MailIcon className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-7153" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-7154">
                Contact Us via Email
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD]" data-id="element-7155">
                Please send your inquiries to{' '}
                <a href="mailto:support@yourdomain.com" className="text-[#2DB489] dark:text-[#4ED1A0] hover:underline" data-id="element-7156">
                  support@yourdomain.com
                </a>
              </p>
              <p className="mt-4 text-gray-600 dark:text-[#B0C1BD]" data-id="element-7157">
                We typically respond within 24 hours.
              </p>
            </div>
            <div className="bg-gray-50 dark:bg-[#1A3330] rounded-lg p-6 mb-6" data-id="element-7158">
              <h2 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-7159">
                What to Include in Your Email
              </h2>
              <ul className="space-y-2 text-gray-600 dark:text-[#B0C1BD]" data-id="element-7160">
                <li className="flex items-start" data-id="element-7161">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7162">
                    •
                  </span>
                  <span data-id="element-7163">Your account email address</span>
                </li>
                <li className="flex items-start" data-id="element-7164">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7165">
                    •
                  </span>
                  <span data-id="element-7166">Order number (if applicable)</span>
                </li>
                <li className="flex items-start" data-id="element-7167">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7168">
                    •
                  </span>
                  <span data-id="element-7169">Detailed description of your issue or question</span>
                </li>
                <li className="flex items-start" data-id="element-7170">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7171">
                    •
                  </span>
                  <span data-id="element-7172">Screenshots (if relevant)</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-lg p-6 text-white" data-id="element-7173">
              <h2 className="text-xl font-semibold mb-2" data-id="element-7174">Support Hours</h2>
              <p className="mb-4 opacity-90" data-id="element-7175">
                Our email support team is available during the following hours:
              </p>
              <div className="space-y-1 mb-4" data-id="element-7176">
                <div className="flex justify-between" data-id="element-7177">
                  <span data-id="element-7178">Monday - Friday:</span>
                  <span data-id="element-7179">9:00 AM - 6:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-7180">
                  <span data-id="element-7181">Saturday:</span>
                  <span data-id="element-7182">10:00 AM - 4:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-7183">
                  <span data-id="element-7184">Sunday:</span>
                  <span data-id="element-7185">Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-7186" />
    </div>;
};